import { MODULES_ENUM } from "types/enums/ModulesEnum";

import { useUrlModule } from "utils/hooks/useUrlModule";

export const useCheckIsProductionModule = () => {
  const module = useUrlModule();
  return module === MODULES_ENUM.OBJECTS;
};
